import React, { FC, memo } from "react";

import { LocalLink } from "./LocalLink";
import { ExternalLink } from "./styled";

export const FeatureCardLink: FC<{ link: string }> = memo(({ link }) => {
  if (!link || typeof link !== "string") return null;

  return link.startsWith("http") ? <ExternalLink onClick={() => window.open(link)} /> : <LocalLink link={link} />;
});
